export const PRODUCT_QUERY_KEYS = {
  GET_PRODUCT: 'GET_PRODUCT',
} as const;
